export type ProfileTab = "MyInfo" | "LoginInfo" | "CommInfo" | "PaymentInfo";

export const PROFILE_TABS: {
  id: ProfileTab;
  label: string;
  showWhen?: (profileAuthInfo: unknown, canProcess: boolean) => boolean;
}[] = [
  { id: "MyInfo", label: "Patient Info", showWhen: () => true },
  {
    id: "LoginInfo",
    label: "Login Info",
    showWhen: (profileAuthInfo) =>
      !!profileAuthInfo && Object.keys(profileAuthInfo as object).length > 0,
  },
  { id: "CommInfo", label: "Communication Preferences", showWhen: () => true },
  {
    id: "PaymentInfo",
    label: "Payment",
    showWhen: (_, canProcess) => canProcess,
  },
];

export function getVisibleProfileTabs(
  profileAuthInfo: unknown,
  canProcess: boolean
) {
  return PROFILE_TABS.filter(
    (tab) => tab.showWhen?.(profileAuthInfo, canProcess) !== false
  );
}

/** Current profile tab from URL, defaulting to MyInfo. */
export function profileTabFromLocation(search: string): ProfileTab {
  const params = new URLSearchParams(search);
  const raw = params.get("page") as ProfileTab | null;
  const valid = PROFILE_TABS.some((t) => t.id === raw);
  if (raw && valid) return raw;
  return "MyInfo";
}

export function isProfilePath(pathname: string) {
  return (
    pathname === "/menu/profile" || pathname.startsWith("/menu/profile/")
  );
}
